module.exports = __webpack_public_path__ + "site/img/103.d6b765cf.jpg";